import { useEffect, useRef } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  jsonLdScripts?: Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  jsonLdScripts = [],
}: SEOHeadProps) {
  const fullTitle = `${title} | 捆绑调教完全指南`;
  const baseUrl = 'https://bondage-guide.com';
  const injectedRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const scripts = document.querySelectorAll('script[data-seo-jsonld]');
    scripts.forEach((s) => s.remove());
    injectedRef.current.clear();

    jsonLdScripts.forEach((scriptData, index) => {
      const key = `ld-${index}`;
      if (!injectedRef.current.has(key)) {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo-jsonld', 'true');
        script.textContent = JSON.stringify(scriptData);
        document.head.appendChild(script);
        injectedRef.current.add(key);
      }
    });

    return () => {
      const currentScripts = document.querySelectorAll('script[data-seo-jsonld]');
      currentScripts.forEach((s) => s.remove());
    };
  }, [jsonLdScripts]);

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={`${baseUrl}${canonicalUrl}`} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`${baseUrl}${canonicalUrl}`} />
      <meta property="og:site_name" content="捆绑调教完全指南" />
      <meta property="og:locale" content="zh_CN" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </>
  );
}